import { ReadArticle } from '../types/ReadArticle'; // Adjust path if ReadArticle is in a separate file

const READ_ARTICLES_STORAGE_KEY = 'readArticles';
const MAX_READ_ARTICLES = 50; // You can adjust this limit as needed

export function getReadArticles(): ReadArticle[] {
    if (typeof window === 'undefined') {
        return []; // Running on server, localStorage not available.
    }
    try {
        const storedReads = localStorage.getItem(READ_ARTICLES_STORAGE_KEY);
        if (storedReads) {
            const parsed = JSON.parse(storedReads);
            if (Array.isArray(parsed)) {
                const validArticles = parsed.filter(item =>
                    typeof item === 'object' &&
                    item !== null &&
                    (typeof item.id === 'string' || typeof item.id === 'number') &&
                    typeof item.type === 'string' &&
                    typeof item.timestamp === 'number'
                ) as ReadArticle[];
              
                return validArticles;
            } else {
                console.warn(`[LocalStorage] getReadArticles: Stored data for '${READ_ARTICLES_STORAGE_KEY}' is not an array or is malformed. Resetting.`);
                return [];
            }
        }
    } catch (error) {
        console.error('[LocalStorage] getReadArticles: Error parsing read articles from localStorage:', error);
    }
    return []; // Default empty array
}

export function addReadArticle(newArticle: Omit<ReadArticle, 'timestamp'>): void {
    if (typeof window === 'undefined') {
        return; // Running on server, localStorage not available.
    }
    try {
        let readArticles = getReadArticles();  
        const articleWithTimestamp: ReadArticle = {
            ...newArticle,
            timestamp: Date.now() // Always assign a new timestamp for the latest read time
        };

        const newArticleUniqueKey = `${articleWithTimestamp.id}__${articleWithTimestamp.type}`;

  
        const uniqueArticlesMap = new Map<string, ReadArticle>();

  
        uniqueArticlesMap.set(newArticleUniqueKey, articleWithTimestamp);


        for (let i = readArticles.length - 1; i >= 0; i--) {
            const existingArticle = readArticles[i];
            const existingArticleUniqueKey = `${existingArticle.id}__${existingArticle.type}`;
            if (!uniqueArticlesMap.has(existingArticleUniqueKey)) {
                uniqueArticlesMap.set(existingArticleUniqueKey, existingArticle);
            }
        }


        readArticles = Array.from(uniqueArticlesMap.values()).reverse();

     


      
        if (readArticles.length > MAX_READ_ARTICLES) {
          //  const removedCount = (readArticles.length - MAX_READ_ARTICLES);
            readArticles = readArticles.slice(0, MAX_READ_ARTICLES);
        
        }

        // Save the final list to localStorage
        localStorage.setItem(READ_ARTICLES_STORAGE_KEY, JSON.stringify(readArticles));
       
      

    } catch (error) {
        console.error('[LocalStorage] addReadArticle: Error saving read article to localStorage:', error);
    }
}

export function isArticleRead(id: string | number, type: string): boolean {
    const readArticles = getReadArticles();
    return readArticles.some(article => article.id === id && article.type === type);
}


export function allReadArticles (){
    return getReadArticles().length;
}

export function clearReadArticles(): void {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        localStorage.removeItem(READ_ARTICLES_STORAGE_KEY);       
    } catch (error) {
        console.error('[LocalStorage] clearReadArticles: Error clearing read articles from localStorage:', error);
    }
}